// src/stockx/flat/CloseCircleIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx } from "react/jsx-runtime";
var CloseCircleIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsx(Icon, { viewBox: "0 0 50 50", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M25.5 6C15 6 6.5 14.5 6.5 25C6.5 35.5 15 44 25.5 44C36 44 44.5 35.5 44.5 25C44.5 14.5 36 6 25.5 6ZM34.4 31.9L32.5 33.8L25.6 26.9L18.7 33.8L16.8 31.9L23.7 25L16.8 18.1L18.7 16.2L25.6 23.1L32.5 16.2L34.4 18.1L27.4 25L34.4 31.9Z",
    fill: colorized ? "#AB1615" : "currentColor"
  }
) });
var CloseCircleIcon_default = CloseCircleIcon;

export {
  CloseCircleIcon_default
};
